var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66927 7H9.33594V16.3333H4.66927C4.05043 16.3333 3.45697 16.0875 3.01939 15.6499C2.5818 15.2123 2.33594 14.6188 2.33594 14V9.33333C2.33594 8.71449 2.5818 8.121 3.01939 7.68342C3.45697 7.24583 4.05043 7 4.66927 7Z",
    fill: "#5096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 16.333H4.375V24.4997H7.29167V16.333Z",
    fill: "#5096FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1641 8.16602C23.0923 8.16602 23.9826 8.53476 24.639 9.19114C25.2953 9.84752 25.6641 10.7378 25.6641 11.666C25.6641 12.5943 25.2953 13.4845 24.639 14.1409C23.9826 14.7973 23.0923 15.166 22.1641 15.166V8.16602Z",
    fill: "#5096FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3409 21.8036L9.33594 16.3436V7.01031L21.3409 1.60864C21.4295 1.56766 21.5269 1.54954 21.6243 1.55595C21.7216 1.56235 21.8158 1.59308 21.8982 1.64531C21.9806 1.69755 22.0486 1.76964 22.096 1.85495C22.1433 1.94026 22.1685 2.03609 22.1693 2.13365V21.3253C22.1612 21.4189 22.1307 21.5091 22.0803 21.5883C22.0299 21.6675 21.9611 21.7335 21.8798 21.7804C21.7985 21.8274 21.707 21.854 21.6132 21.858C21.5194 21.8621 21.426 21.8434 21.3409 21.8036Z",
    fill: "#CBDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.a390cd93e63ac3fec9fcd7b6729c59e7.svg";
export { ForwardRef as ReactComponent };